import React from 'react';

const OrderStatusInit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#00CE64"
      fillRule="evenodd"
      d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm2 5a1 1 0 1 0 0 2h4a1 1 0 0 0 0-2H8zm0 4a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2H8zm0 4a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2H8z"
    />
  </svg>
);

export default OrderStatusInit;
